import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setProductcompositionFilterCriteria } from 'store/slice/PharmaSlice';

export default function ProductcompositionFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.productcompositionDashboard);
        
    const {compositionList} = useSelector((state)=>state.pharmaslice);
    
const updateCompositionnameCriteria = (compositionname) =>{
        dispatch(setProductcompositionFilterCriteria(
            {
                ...filterCriteria,
                compositionname:compositionname
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Compositionname"
                            name="compositionname"
                            value={filterCriteria.compositionname}
                            onChange={(e)=>updateCompositionnameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}